import { Controller } from '@hotwired/stimulus'
import { isNumericNotZero } from 'util/validation'

// Connects to data-controller="batch-activity-opt-ins"
export default class extends Controller {
  static targets = ['goalsField', 'goalSourceField']

  update () {
    const result = {}

    this.goalSourceFieldTargets.forEach(target => {
      if (isNumericNotZero(target.value)) {
        result[target.dataset.salesActivity] = target.value
      }
    })

    this.goalsFieldTarget.value = JSON.stringify(result)
  }
}
